 
import './App.css';
 
import './components_root/input_tools.css';
import './components_root/button_ui.css'; 
import React, { useState, useRef, useEffect } from 'react';
import { db } from "./firebase.js";
import { useNavigate, useLocation ,Routes, Route } from 'react-router-dom';
import { collection, getDocs, query, where, doc, updateDoc, orderBy, limit, setDoc, Timestamp } from "firebase/firestore"; 
import ReactDOM from "react-dom";
import Cookies from 'js-cookie';
import "./index.css";
import Header from "./body_root/header.jsx";
import Footers from "./body_root/footer.jsx";
import Navbar from "./body_root/Navbar.jsx";
import { Approutes } from './routes';
import { FaArrowUp } from 'react-icons/fa';  // For arrow icon
import Idpage from './pages/idpage';
import ScrollToTop from './body_root/ScrollToTop.jsx';
import { getAuth, signInAnonymously } from "firebase/auth";
import { auth } from "./firebase";

function App() {
  const auth = getAuth();
  signInAnonymously(auth).catch((error) => {
  console.error("Anonymous sign-in failed:", error);
});
       const navigate = useNavigate();
  const location = useLocation();
     const [isVisible, setIsVisible] = useState(false);
 

  function scrollToTop(duration = 5000) {
  const start = window.pageYOffset || document.documentElement.scrollTop;
  const startTime = performance.now();

  function step(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1); // progress from 0 to 1
    // Easing function: easeOutCubic (smooth deceleration)
    const easeOutCubic = t => 1 - Math.pow(1 - t, 3);
    const value = start * (1 - easeOutCubic(progress));

    window.scrollTo(0, value);

    if (progress < 1) {
      requestAnimationFrame(step);
    }
  }

  requestAnimationFrame(step);
}
// useEffect(() => {
//     const checkSessionAndAccount = async () => {
//       const sessionToken = Cookies.get("sessiontoken");
//       const guid = Cookies.get("guid");
//       if (sessionToken) {
//         const checkQuery = query(
//           collection(db, "accounts"),
//           where("status", "==", true),
//           where("guid", "==", guid)
//         );
//         const checkSnap = await getDocs(checkQuery);
//         if (!checkSnap.empty) {
//           const userDoc = checkSnap.docs[0];
//           const userData = userDoc.data();
//           if (userData.newuser === true) {
//             navigate("/referral-code");
//           }
//         } else {
//           // Optional: Handle case where no matching account is found
//           console.log("No account found for the given GUID.");
//         }
//       } else {
//         // Optional: Handle when sessionToken is not present
//         console.log("No session token found.");
//       }
//     };

//     checkSessionAndAccount();
//   }, [navigate]);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 10) {
        setIsVisible(true);
        const headerElement = document.getElementsByClassName('header')[0];
        if (headerElement) {
          headerElement.style.WebkitBoxShadow = "0px 5px 5px -4px rgba(0,0,0,0.1)";
          headerElement.style.MozBoxShadow = "0px 5px 5px -4px rgba(0,0,0,0.1)";
          headerElement.style.boxShadow = "0px 5px 5px -4px rgba(0,0,0,0.1)";
        }
        const statusbarElement = document.getElementsByClassName('status-bar')[0];
        if (statusbarElement) {
          statusbarElement.style.WebkitBoxShadow = "0px 5px 5px -4px rgba(0,0,0,0)";
          statusbarElement.style.MozBoxShadow = "0px 5px 5px -4px rgba(0,0,0,0)";
          statusbarElement.style.boxShadow = "0px 5px 5px -4px rgba(0,0,0,0)";
        }
      }
      else {
        setIsVisible(false);
        const headerElement = document.getElementsByClassName('header')[0];
        if (headerElement) {
          headerElement.style.WebkitBoxShadow = "0px 5px 5px -4px rgba(0,0,0,0.00)";
          headerElement.style.MozBoxShadow = "0px 5px 5px -4px rgba(0,0,0,0.00)";
          headerElement.style.boxShadow = "0px 5px 5px -4px rgba(0,0,0,0.00)";
        }
        const statusbarElement = document.getElementsByClassName('status-bar')[0];
        if (statusbarElement) {
          statusbarElement.style.WebkitBoxShadow = "0px 5px 5px -4px rgba(0,0,0,0.0)";
          statusbarElement.style.MozBoxShadow = "0px 5px 5px -4px rgba(0,0,0,0.0)";
          statusbarElement.style.boxShadow = "0px 5px 5px -4px rgba(0,0,0,0.0)";
        }
      }
    };
    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);
  useEffect(() => {
    const fetchLocationData = async () => {
      try {
        const ipRes = await fetch('https://ipapi.co/json/');
        const ipData = await ipRes.json();

        const usercountryname = ipData.country_name || "no";
        const usercity = ipData.city || "no";
        const userstate = ipData.region || "no";
        const userpostcode = ipData.postal || "no";
        const userphonecode = ipData.country_calling_code ? ipData.country_calling_code.replace("+", "") : "no";
        const useripaddress = ipData.ip || "no";
        let userlatitude = ipData.latitude || "no";
        let userlongitude = ipData.longitude || "no";

        Cookies.set("ipaddres", useripaddress, { expires: 365 });
        Cookies.set("latitude", userlatitude, { expires: 365 });
        Cookies.set("longitude", userlongitude, { expires: 365 });

        Cookies.set("country", usercountryname, { expires: 365 });
        Cookies.set("city", usercity, { expires: 365 });
        Cookies.set("state", userstate, { expires: 365 });
        Cookies.set("postcode", userpostcode, { expires: 365 });

        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            async (position) => {
              userlatitude = position.coords.latitude;
              userlongitude = position.coords.longitude;

              try {
                const response = await fetch(
                  `https://maps.googleapis.com/maps/api/geocode/json?latlng=${userlatitude},${userlongitude}&key=AIzaSyC3S4_yTEhJsCBzQ76_tIf8FusVUw6Fc3A`
                );
                const geoData = await response.json();
                const useraddress = geoData.results[0]?.formatted_address || "Not Found";
                console.log("📍 Full Address:", useraddress);
              } catch (geoError) {
                console.error("❌ Error with reverse geocoding:", geoError);
              }
            },
            (geoError) => {
              console.error("❌ Error with geolocation access:", geoError);
            }
          );
        } else {
          console.error("❌ Geolocation not supported by browser.");
        }

      } catch (err) {
        console.error("❌ Error fetching IP data:", err);
      }
    };

    fetchLocationData();
  }, []);
const [statusmenu, setStatusmenu] = useState(false);

useEffect(() => {
  if (location.pathname === "/ads") {
    setStatusmenu(true);
  } else {
    setStatusmenu(false);
  }
}, [location.pathname]);     
  return (
    <div >
        <Header />
      
    {/* {statusmenu === false && <CategoryMenu />} */}
       
      <ScrollToTop />
      {isVisible && (
        <button onClick={scrollToTop} className="scroll-to-top-btn" title="Scroll to top">
          <FaArrowUp />
        </button>
      )}
      <Routes>

        {Approutes.map(({ path, element }, i) => (
          <Route key={i} path={path} element={element} />
        ))}
        <Route path="/:id" element={<Idpage />} />
      </Routes>
       
        {/* {statusmenu === false && <Footers />} */}
        <Footers />
       <Navbar />
    </div>
  );
}

export default App;
